import { render, staticRenderFns } from "./CustomRadioGroup.vue?vue&type=template&id=f0095194&scoped=true&"
import script from "./CustomRadioGroup.vue?vue&type=script&lang=js&"
export * from "./CustomRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0095194",
  null
  
)

export default component.exports